import {Component, Injectable, TemplateRef} from '@angular/core';

import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import Swal from 'sweetalert2';
import {AuthenticationService} from './authentication.service';


@Injectable({
  providedIn: 'root'
})
export class GenericModalService {

  constructor(private modalService: BsModalService, private authService: AuthenticationService) { }

  showModal(component: Component, title: string, id: number = 0, message: string = null, size: string = 'modal-lg') {
    const objId = id;
    const objMessage = message;
    const bsModalRef: BsModalRef = this.modalService.show(component,
      { initialState: { objId, objMessage }, class: size, backdrop: 'static'});
    bsModalRef.content.modalTitle = title;
    return (bsModalRef.content).itemSaved;
  }

  showXlModal(component: Component, title: string, id: number = 0, additionalClassName: string) {
    return this.showModal(component, title, id, additionalClassName, 'modal-xl');
  }

  showObjModal(component: Component, title: string, objInitialState: any, size: string = 'modal-lg') {
    if (this.authService.checkAuthModal()) {
      const bsModalRef: BsModalRef = this.modalService.show(component,
        {initialState: {objInitialState}, class: size, backdrop: 'static'});

      bsModalRef.content.modalTitle = title;
      return (bsModalRef.content).itemSaved;
    }
  }

  showObjModalWithTemplate(templateRef: TemplateRef<any>, objInitialState: any, size: string = 'modal-lg') {
    const bsModalRef: BsModalRef = this.modalService.show(templateRef,
      { initialState: { objInitialState }, class: size, backdrop: 'static'});

    return bsModalRef;
  }

  showInputModal(component: Component, title: string, description: string, okButton: string, cancelButton: string,
                 inputSuggestion: string, validationPattern: string, patternErrorMessage: string, maxLength: number,
                 minLength: number, isRequired: boolean, cleanSpaces: boolean = true) {
    const bsModalRef: BsModalRef = this.modalService.show(component,
      { initialState: { inputSuggestion }, backdrop: 'static' });
    bsModalRef.content.modalTitle = title;
    bsModalRef.content.modalDescription = description;
    bsModalRef.content.okButton = okButton;
    bsModalRef.content.cancelButton = cancelButton;
    bsModalRef.content.validationPattern = validationPattern;
    bsModalRef.content.patternErrorMessage = patternErrorMessage;
    bsModalRef.content.maxLength = maxLength;
    bsModalRef.content.minLength = minLength;
    bsModalRef.content.isRequired = isRequired;
    bsModalRef.content.cleanSpaces = cleanSpaces;
    return (bsModalRef.content).input;
  }

  showselectModal(component: Component, title: string, description: string, okButton: string, cancelButton: string, listOfItems: any[]) {
    const bsModalRef: BsModalRef = this.modalService.show(component,
      { initialState: { listOfItems }, backdrop: 'static' });
    bsModalRef.content.modalTitle = title;
    bsModalRef.content.modalDescription = description;
    bsModalRef.content.okButton = okButton;
    bsModalRef.content.cancelButton = cancelButton;
    return (bsModalRef.content).selectedItem;
  }

  showConfirmModal(title: string, message: string) {
    const alert = Swal.fire({
      title: title,
      html: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      buttonsStyling: false,
      customClass: {
        cancelButton: 'btn btn-outline-secondary',
        confirmButton: 'btn btn-primary mr-3'
      },
      allowOutsideClick: false
    });
    return alert;
  }

/*  showModalTeste(component: Component, title: string, id: number = 0, message: string = null) {
    const comp: any = GenericModalComponent;
    const objId = id;
    const objMessage = message;
    const bsModalRef: BsModalRef = this.modalService.show(comp,
      { initialState: { objId, objMessage, component }, class: 'modal-lg', backdrop: 'static'});
    bsModalRef.content.modalTitle = title;
    return (bsModalRef.content).itemSaved;
  }*/

  /*auth() {
    const token = localStorage.getItem('TokenInfo');

    if (token && this.jwtHelper.isTokenExpired(token)) {
      this.forceCloseModal();
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }

  forceCloseModal() {
    for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
      this.modalService.hide(i);
    }
    document.body.className = document.body.className.replace('modal-open', '');
  }*/

  showMessage(text: string, showButton: boolean, timer: number, title: string = null) {
    Swal.mixin({
      title: title,
      toast: true,
      position: 'top',
      timer: timer,
      showClass : { popup : 'swal2-noanimation', backdrop : 'swal2-noanimation', icon : 'swal2-noanimation'},
      html: `<div style="overflow: auto;max-height: 300px">${text}</div>`,
      showConfirmButton: showButton,
      confirmButtonColor: '#0c5460',
      background: '#ffffff',
      width: '50%'
    }).fire();
  }

  showInfoMessage(text: string, showButton: boolean, timer: number, title: string = null) {
    Swal.mixin({
      title: title,
      toast: true,
      position: 'top',
      timer: timer,
      icon: 'info',
      showClass : { popup : 'swal2-noanimation', backdrop : 'swal2-noanimation', icon : 'swal2-noanimation'},
      html: `<span style="color: #0c5460;">${text}</span>`,
      showConfirmButton: showButton,
      confirmButtonColor: '#0c5460',
      background: '#d1ecf1',
      width: '50%'
    }).fire();
  }

  showErrorMessage(text: string, showButton: boolean) {
    Swal.mixin({
      toast: true,
      position: 'top',
      showClass : { popup : 'swal2-noanimation', backdrop : 'swal2-noanimation', icon : 'swal2-noanimation'},
      html: `<span style="color: #721c24;">${text}</span>`,
      showConfirmButton: showButton,
      confirmButtonColor: '#721c24',
      background: '#f8d7da',
      width: '50%'
    }).fire();
  }

  showSuccessMessage(text: string, showButton: boolean, timer: number) {
    Swal.mixin({
      toast: true,
      position: 'top',
      timer: timer,
      icon: 'success',
      showClass : { popup : 'swal2-noanimation', backdrop : 'swal2-noanimation', icon : 'swal2-noanimation'},
      html: `<span style="color: #155724;">${text}</span>`,
      showConfirmButton: showButton,
      confirmButtonColor: '#155724',
      background: '#d4edda',
      width: '50%'
    }).fire();
  }
}
